// chartSourceGuard — refuse to insert a chart over a data block whose
// value region never got its data. A dashboard that LOOKS complete but
// carries blank charts is worse than a visible error: the user can't
// tell whether the numbers were wrong or missing (prod incident,
// 2026-07-10). Emptiness = every cell outside the header row and label
// column is blank. Zeros are REAL data (all-zero series are legitimate);
// only null/'' count as missing.
export function chartSourceLooksEmpty(values: readonly (readonly unknown[])[]): boolean {
  if (values.length < 2 || (values[0]?.length ?? 0) < 2) return false;
  for (let r = 1; r < values.length; r++) {
    for (let c = 1; c < values[r].length; c++) {
      const v = values[r][c];
      if (v !== null && v !== undefined && v !== '') return false;
    }
  }
  return true;
}
